



















import Vue, { PropOptions } from 'vue';
import md5 from 'md5';

import { User } from '../../types';

/**
 * Renders the users Gravatar image in a circle. Gravatar will auto generate an 0 opacity image for
 * emails it does not recognise and reveales the user initials or user name inittial.
 * Requires the MD5 package as per the baseplates peerDependencies
 */
export default Vue.extend({
  name: 'SAvatar',
  props: {
    email: {
      type: String,
      required: false,
    },
    user: {
      type: Object,
      required: false,
    } as PropOptions<User>,
    size: {
      type: Number,
      required: false,
      default: 38,
    },
  },
  computed: {
    imageUrl(): string {
      const userEmail = this.email || this.user.email;
      const placeHolder = this.email ? 'mp' : 'blank';
      return (
        `https://www.gravatar.com/avatar/${
          md5(userEmail)
        }?s=600&d=${placeHolder}`
      );
    },
    imageAlt(): string {
      if (!this.user) return this.email;
      const { firstName, lastName } = this.user;
      return `${firstName} ${lastName}`;
    },
    // Gets the users initials if a user object is passes
    userInitials(): string {
      if (this.user) {
        const { firstName, lastName, userName } = this.user;
        const first = firstName[0] || '';
        const second = lastName[0] || '';
        const initials = first || second ? `${first}${second}` : userName[0];
        return initials.toUpperCase();
      }
      return '';
    },
    backgroundColor(): string {
      if (!this.userInitials) return 'neutral lighten-1';
      return this.getHexColourFromString(this.userInitials);
    },
  },
  methods: {
    getHexColourFromString(string) {
      const colours = [
        '#1ABC9C',
        '#2ECC71',
        '#3498DB',
        '#c49fd4',
        '#16A085',
        '#27AE60',
        '#2980B9',
        '#F1C40F',
        '#E67E22',
        '#ea877c',
        '#F39C12',
        '#a1add0',
      ];

      let hash = 0;
      string.split('').forEach((letter, index) => {
        hash = string.charCodeAt(index) + hash;
      });

      const colourPos = hash % colours.length;
      return colours[colourPos];
    },
  },
});
